import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Stack,
  useBreakpointValue,
  useDisclosure,
} from "@chakra-ui/react";
import { GiHamburgerMenu } from "react-icons/gi";
import { useNavigate } from "react-router";
import { useContaxt } from "../context/Context";
import { HeaderLink } from "./header/HeaderLink";
import { services } from "./header/services";

export function BurgerMenu({ refs, executeScroll }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { color } = useContaxt();
  const navigate = useNavigate();
  const size = useBreakpointValue({ base: 36, sm: 48, md: 48 });

  return (
    <>
      <GiHamburgerMenu
        color={color.mainColor}
        size={size}
        onClick={() => (isOpen ? onClose() : onOpen())}
        cursor={"pointer"}
      />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent mt={["70px", "90px", "90px", "90px"]} borderRadius={0}>
          <ModalBody px={0} w={"100%"}>
            <Stack>
              {services.map((service, i) => {
                return (
                  <HeaderLink
                    key={i}
                    service={service}
                    onClick={() => {
                      navigate("/");
                      setTimeout(() => {
                        executeScroll(service.ref);
                      }, 300);
                      onClose();
                    }}
                  />
                );
              })}
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
